import { render, staticRenderFns } from "./DSButton.vue?vue&type=template&id=63562c7e&scoped=true&"
import script from "./DSButton.vue?vue&type=script&lang=ts&"
export * from "./DSButton.vue?vue&type=script&lang=ts&"
import style0 from "./DSButton.vue?vue&type=style&index=0&id=63562c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63562c7e",
  null
  
)

export default component.exports